export class PromoCodeApplyError extends Error {
    constructor(message: string = 'Промокод не найден') {
        super(message);
        this.name = 'PromoCodeApplyError';
    }
}
